export enum adminScoutMatchingJobsTypes {
    FETCH_ADMIN_SCOUT_MATCHING_JOBS_REQUEST = "FETCH_ADMIN_SCOUT_MATCHING_JOBS_REQUEST",
    FETCH_ADMIN_SCOUT_MATCHING_JOBS_SUCCESS = "FETCH_ADMIN_SCOUT_MATCHING_JOBS_SUCCESS",
    FETCH_ADMIN_SCOUT_MATCHING_JOBS_FAILURE = "FETCH_ADMIN_SCOUT_MATCHING_JOBS_FAILURE",
  }